export default __webpack_public_path__ + "static/media/Path -2.27c4e81e.png";